// extracted by mini-css-extract-plugin
export default {"Box":"table-group-module__Box--rARIB","isOver":"table-group-module__isOver--IlIud"};